import InterActiveCommunityMap from "../screens/interactiveCommunityMap/InteractiveCommunityMap";
import {VscFullScreenContent} from "./ContentComponent";


const VscAmenityMap: React.FC<{id: string, theme:string}> = (props) => {
    const { id, theme } = props;
    return <InterActiveCommunityMap id={id} theme={theme} />
}
export default VscAmenityMap;